import React from 'react';
import PropTypes from 'prop-types';

import FormControl from 'src/app/components/FormControl/FormControl';
import EmailSuggester from 'src/app/components/EmailSuggester/EmailSuggester';


class Email extends React.PureComponent {
  render() {
    const {
      onBlur,
      onChange,
      onFocus,
      onPickedEmail,
      value,
      validationMessage,
      markedAsWrong,
      focus,
      disabled,
      apiError,
      inputRef,
      dataTest
    } = this.props;

    return (
      <FormControl {
                     ...{
                       value,
                       validationMessage,
                       markedAsWrong,
                       focus,
                       apiError,
                       disabled
                     }
                   }
                   label="Adres e-mail"
      >

        <EmailSuggester change={ onChange }
                        focus={ onFocus }
                        blur={ onBlur }
                        pickedEmail={ onPickedEmail }
                        {
                          ...{
                            dataTest,
                            inputRef,
                            value
                          }
                        }
        />

      </FormControl>
    );
  }
}

Email.propTypes = {
  onPickedEmail: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  dataTest: PropTypes.string.isRequired,
  onBlur: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  inputRef: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};


export default Email;
